<template>
  <div class="form-group" :class="{ 'has-error': formError }">
    <form
      action=""
      class="mt-4 sm:flex sm:max-w-md"
      @submit.prevent="sendSignup"
    >
      <label for="email-address" class="sr-only">{{ lang.labels.input }}</label>
      <input
        type="email"
        name="email-address"
        id="email-address"
        autocomplete="email"
        required
        class="appearance-none min-w-0 w-full bg-white border border-transparent rounded-md py-2 px-4 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white focus:border-white focus:placeholder-gray-400"
        :placeholder="lang.labels.email"
        v-model="email"
        :disabled="disableForm"
      />
      <div class="mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0">
        <button
          type="submit"
          class="w-full bg-primary-800 border border-transparent rounded-md py-2 px-4 flex items-center justify-center text-base font-medium text-white hover:bg-primary-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-primary-500 disabled:bg-primary-400"
          :disabled="disableForm"
        >
          <span v-show="!showConfirmation">{{ lang.labels.send }}</span>
          <span v-show="showConfirmation"><i class="fas fa-check"></i></span>
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  lang: Object,
  source: {
    type: String,
    default: "",
  },
});

const disableForm = ref(false);
const email = ref("");
const showConfirmation = ref(false);
const formError = ref(false);

const validateForm = () => {
  if (email.value === "") {
    return false;
  }
  return true;
};

const sendSignup = () => {
  disableForm.value = true;
  formError.value = false;

  if (!validateForm()) {
    disableForm.value = false;
    formError.value = true;
    return;
  }

  axios
    .post(`/web-api/newsletter/signup`, {
      email: email.value,
      source: props.source,
    })
    .then((response) => {
      showConfirmation.value = true;
      window.location.href = "/newsletter/thank-you";
    })
    .catch((error) => {
      formError.value = true;
      disableForm.value = false;
    });
};
</script>
